import { render } from "./TicketsListSecondaryTitle.vue?vue&type=template&id=36c3c8be"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "36c3c8be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36c3c8be', script)) {
    api.reload('36c3c8be', script)
  }
  
  module.hot.accept("./TicketsListSecondaryTitle.vue?vue&type=template&id=36c3c8be", () => {
    api.rerender('36c3c8be', render)
  })

}

script.__file = "src/views/support/pageTitles/TicketsListSecondaryTitle.vue"

export default script